import {Injectable} from '@angular/core';
import {SmmService} from './smm.service';

@Injectable()
export class SmmPostService {


  constructor(private smmService: SmmService) {
  }

  public searchPosts(body) {
    return this.smmService.getPosts(body);
  }

  public searchPostsByType(body) {
    return this.smmService.getPostsByType(body);
  }
  public searchDataByType(body) {
    return this.smmService.getDataByType(body);
  }

  public getAllOrder(body) {
    return this.smmService.getAllOrder(body);

  }


  // TMHIEP: 18/08/2020 - Nguồn thảo luận
  public searchPostsDiscussionSource(body) {
    return this.smmService.getPostsDiscussionSource(body);
  }

  // TMHIEP: 19/08/2020 - Diễn biến thảo luận
  public searchPostsDiscussionEvolution(body) {
    return this.smmService.getPostsDiscussionEvolution(body);
  }

  // TMHIEP: 21/08/2020 - Sắc thái thảo luận
  public searchDiscussionShade(body) {
    return this.smmService.getDiscussionShade(body);
  }

  // TMHIEP: 25/08/2020 - Chi tiết thảo luận
  public searchDetailDiscussion(body) {
    return this.smmService.getDetailDiscussion(body);
  }

  // TMHIEP: 28/08/2020 - Chủ đề thảo luận
  public searchPostsDiscussionProject(body) {
    return this.smmService.getPostsDiscussionProject(body);
  }

  // TMHIEP: 01/09/2020 - Chân dung tác giả
  public searchAuthorPortrait(body) {
    return this.smmService.getAuthorPortrait(body);
  }

  public searchPostsByGroup(body) {
    return this.smmService.getPostsByGroup(body);
  }

  public searchVideos(body) {
    return this.smmService.getVideos(body);
  }

  public findPostById(id:String, body){
    return this.smmService.getPostsById(id, body);
  }

  // TMHIEP
  public findPostByIdAndIndex(id:String, postIndex:String, body){
    return this.smmService.getPostsByIdAndIndex(id, postIndex, body);
  }

  //viettung bo sung reply comment
  public replyComment(body) {
    // console.log(JSON.stringify(body));
    return this.smmService.replyComment(body);
  }

  public sharePost(body) {
    return this.smmService.sharePost(body);
  }

  public editComment(body) {
    //console.log('202005121503 editComment====>',body);
    return this.smmService.editComment(body);
  }


  public deleteComment(body) {
    //console.log('202005121502 deleteComment====>',body);
    return this.smmService.deleteComment(body);
  }
  //viettung
  //thanh dv
  public getCountPostCommentIsProcess(body) {
    return this.smmService.getCountPostCommentIsProcess(body);
  }
  public getCountCommentIsProcess(body) {
    return this.smmService.getCountCommentIsProcess(body);
  }

  //badv like comment
  public likeComment(body) {
    // console.log(JSON.stringify(body));
    return this.smmService.likeComment(body);
  }

  //badv like comment
  public dislikeComment(body) {
    // console.log(JSON.stringify(body));
    return this.smmService.dislikeComment(body);
  }

  //badv like comment
  public likePost(body) {
    // console.log(JSON.stringify(body));
    return this.smmService.likePost(body);
  }

  //badv like comment
  public dislikePost(body) {
    // console.log(JSON.stringify(body));
    return this.smmService.dislikePost(body);
  }

  //anhntuan
  public searchDiscussionProvince(body) {
    return this.smmService.getPostsDiscussionProvince(body);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/smm-post.service.ts